import { render, staticRenderFns } from "./AddRecordOffline.vue?vue&type=template&id=71fd7a5e&scoped=true&"
import script from "./AddRecordOffline.vue?vue&type=script&lang=js&"
export * from "./AddRecordOffline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fd7a5e",
  null
  
)

export default component.exports